export const subscriptionEnabled = import.meta.env.VITE_SUBSCRIPTION_ENABLED === "true";
